<template>
  <div>
    <div class="head">
      <div class="search">
        <div class="ser_logo">
          <div class="ser-logo-img">
            <img src="@/assets/img/logo.jpg">
          </div>
          <div class="ser-logo-title">
            <!-- <p>职业教育新课堂</p>
            <p>New Classroom for Vocational Education</p>
            <p>湖南中教国培教育咨询服务有限公司</p>
            <p>Hunan Zhongjiao Guopei Education Consulting Service Co., Ltd</p> -->
            <p>
              <span class="fontSize fontFamily"
                    style="letter-spacing: 7px;">新时代职业教育教师发展联盟</span>
              <span class="fontFamilyB"
                    style="letter-spacing: 1.7px;">New Era Vocational Education Teacher Development
                Alliance</span>
            </p>
            <p>
              <!-- <span class="fontSizeA fontFamily">新时代职教云课堂</span> -->
              <span class="fontSizeA fontFamily">中教国培（湖南）教育咨询服务中心</span>
              <!-- <span class="fontFamilyA">New&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Classroom&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vocational&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Education</span> -->
              <!-- <span class="fontFamilyA">New Era Vocational Education Cloud Classroom</span> -->
              <span class="fontFamilyA">China Education and Training (Hunan) Education Consulting Service Center</span>
            </p>
          </div>
        </div>
        <div class="ser_qrcode">
          <img src="@/assets/img/ewpcode.jpg">
          <p>新时代职教云课堂</p>
        </div>
      </div>
      <div class="sub_header">
        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 @select="handleSelect"
                 :router="true">
          <template v-for="item in routerList">
            <template v-if="item.children && item.children.length > 0">
              <el-submenu :index="item.name"
                          :key="item.name"
                          popper-class="popNavClass">
                <template slot="title">{{ item.meta.title }}</template>
                <el-menu-item v-for="(uitem, uindex) in item.children"
                              :key="uindex"
                              :index="uitem.name"
                              :route="{ name: uitem.name }">{{ uitem.meta.title }}</el-menu-item>

              </el-submenu>
            </template>
            <template v-if="!item.children && !item.hidden">
              <el-menu-item :index="item.name"
                            :key="item.name"
                            :route="{ name: item.name }">{{ item.meta.title
              }}</el-menu-item>
            </template>
          </template>

        </el-menu>

      </div>
    </div>
    <div class="breadcrumb-wrap"
         v-if="isShowCrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in crumbItemList"
                            :key="index"
                            :to="{ path: item.path }">{{
          item.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
// import router from '@/router'
const singInPath = ['/expert', '/train']
export default {
  name: 'MyHeader',
  data () {
    return {
      activeIndex: 'Home',
      isShowCrumb: false,
      crumbItemList: []
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {
    if (this.$route.matched) {
      this.crumbItemList = this.setMapMatchedList(this.$route.matched)
    }
    if (this.$route.name !== 'Home') {
      this.isShowCrumb = true;
    }

  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () {

  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name === 'Home') {
          this.isShowCrumb = false;
        } else {
          this.isShowCrumb = true;
          let matchedList = [];
          if (val.name === 'detail') {
            // this.isShowCrumb = false;
            let oldMatchedList = this.setMapMatchedList(oldVal.matched);
            if (oldMatchedList.length > 0 && oldVal.name && oldVal.name !== 'Home') {
              //存储
              window.localStorage.setItem('matchedList', JSON.stringify(oldMatchedList));
            } else {
              //取值
              oldMatchedList = JSON.parse(window.localStorage.getItem('matchedList'));
              if (oldMatchedList.length === 0) {
                this.isShowCrumb = false;
              }
            }
            matchedList = [...oldMatchedList, {
              title: val.meta.title,
              path: val.path
            }]
          } else {
            //获取标签
            const matched = val.matched;
            matchedList = this.setMapMatchedList(matched)
          }
          //获取标签
          // const matched = val.matched;
          this.crumbItemList = matchedList;

          //设置选中状态 详情页面
          let apath = '';
          if (val.name === 'detail') {
            const pathList = JSON.parse(window.localStorage.getItem('matchedList'));
            if (singInPath.includes(oldVal.path) || singInPath.includes(pathList?.[0]?.path)) {
              apath = pathList?.[0]?.path;
            } else {
              apath = pathList?.[1]?.path;
            }
          } else {
            apath = val.path;
          }
          this.setMenuActive(apath);
          // this.activeIndex = val.name;
        }
      }
    }
  },
  computed: {
    routerList: function () {
      const routes = this.$router.options.routes;
      const list = routes.filter(item => item.name)
      return list;
    }
  },
  methods: {
    handleSelect: function (index) {
      this.activeIndex = index;
    },
    toBreadRouetr: function (path) {
      this.$router.push({
        name: path
      })
    },
    setMapMatchedList (matched) {
      return matched ? matched.map(item => {
        return {
          title: item.meta.title,
          path: item.path
        }
      }) : [];
    },
    //设置选中状态
    setMenuActive (_path) {
      const reg = /\/\w+/g;
      const pathList = _path.match(reg);
      if (!pathList) return;

      for (let i = 0; i < this.routerList.length; i++) {
        const item = this.routerList[i];
        if (item.path === pathList[0] && item.children) {
          // this.activeIndex = item.name;
          for (let j = 0; j < item.children.length; j++) {
            const citem = item.children[j];
            if (('/' + citem.path) === pathList[1]) {
              this.activeIndex = citem.name;
            }
          }
        }
        if (item.path === pathList[0] && !item.children) {
          this.activeIndex = item.name;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.head {
  height: 220px;
  width: 100%;
  background-color: #000;
  background: url(@/assets/img/warpbg1.jpg) center no-repeat;
  // background: #2b9eed;
  background-size: cover;
  position: relative;
  box-shadow: 0px 1px 6px 0px rgba(37, 115, 207, 0.57);

  .search {
    display: flex;
    // min-width: 1200px;
    overflow: hidden;
    height: 160px;
    justify-content: space-between;

    .ser_logo {
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 11%;

      .ser-logo-img {
        display: flex;
        height: auto;
        width: 125px;
        // background: #ffffff;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .ser-logo-title {
        margin-left: 20px;

        p {
          font-size: 23px;
          color: rgb(24, 141, 192);
          display: flex;
          flex-direction: column;
          // display: inline-block;

          .fontSize {
            font-size: 28px;
            letter-spacing: 3px;
          }

          .fontSizeA {
            font-size: 28px;
            letter-spacing: 0px;
          }

          .fontFamily {
            font-family: "AliHeiBold";
          }

          .fontFamilyA {
            font-size: 13px;
            letter-spacing: 0.1px;
          }

          .fontFamilyB {
            font-size: 13px;
          }

          &:first-child {
            // line-height: 35px;
            // font-size: 33px;
            margin-bottom: 15px;
            // letter-spacing: 17px;
          }
        }
      }
    }

    .ser_qrcode {
      display: flex;
      // margin-right: 50px;
      margin-right: 11%;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      img {
        width: 100px;
        height: 100px;
        margin-bottom: 10px;
      }

      p {
        color: #ffffff;
        font-size: 16px;
      }
    }
  }

  .sub_header {
    height: 60px;
    // width: 1200px;
    margin: 0px auto;
    bottom: 0;
    padding-left: 11%;

    .el-menu {
      background: transparent;
    }

    .el-menu--horizontal > .el-menu-item {
      color: rgb(24, 141, 192);
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-family: "AliHeiBold";

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }

      &.is-active {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }

      &:focus {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }
    }

    ::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
      color: rgb(24, 141, 192);
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-family: "AliHeiBold";

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }

      &:focus {
        background-color: rgba($color: #000000, $alpha: 0.2);
      }

      .el-submenu__icon-arrow {
        margin-left: 0;

        &:before {
          content: "";
        }
      }
    }

    ::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      background-color: rgba($color: #000000, $alpha: 0.2);
    }
  }

  .sub_choice {
    position: absolute;
    height: 6px;
    width: 60%;
    background-color: #fff;
    bottom: 0;
    left: 20%;
  }
}

.breadcrumb-wrap {
  display: flex;
  margin: 15px 0px 15px 11%;

  span {
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.popNavClass {
  .el-menu--popup {
    min-width: 120px;

    .el-menu-item {
      min-width: 120px;
      font-size: 16px;
      font-family: "AliHeiBold";
    }
  }
}
</style>